import { useState, useEffect } from "react";
import { useGlobalContext } from "../GlobalContext";
import TransaksiManasukapdf from "./report/pdf/transaksimanasuka";

const TransaksiManasuka = () => {
	const tglSekarang = new Date().toISOString().split("T")[0];
    const { periode, api, kode } = useGlobalContext();

    const [formData, setFormData] = useState({
        noTransaksi: "",
        tglTransak: tglSekarang, // Gunakan tanggal yang terkunci
        noAnggota: "",
        nama: "",
        unitkerja: "",
        saldoAwl: 0,
        anggota_mnsuka: "0",
        jenisTransaksi: "1",
        jumlah: 0,
        saldoAkhir: 0,
        kduser:kode,
        notransumum:"-"
    });

    const formatCurrency = (value) => {
        return new Intl.NumberFormat("id-ID").format(value);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === "jumlah" || name === "saldoAwl") {
            const cleanValue = value.replace(/[^0-9]/g, "");
            setFormData((prev) => ({
                ...prev,
                [name]: parseFloat(cleanValue) || 0,
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    useEffect(() => {
        if (periode) {
            GenereateNoTrans();
        }
    });

    useEffect(() => {
        const saldoAwal = Number(formData.saldoAwl) || 0;
        const jumlah = Number(formData.jumlah) || 0;
        const saldoAkhir = formData.jenisTransaksi === "1" ? saldoAwal + jumlah : saldoAwal - jumlah;

        setFormData((prev) => ({
            ...prev,
            saldoAkhir: saldoAkhir,
        }));
    }, [formData.jenisTransaksi, formData.saldoAwl, formData.jumlah]);

    const GenereateNoTrans = async () => {
        const noawal = periode.toString();
        const notransaksiwal = noawal.substring(2, 6);

        try {
            const response = await api.get(`/api/transaksi/getnotransaksimanasuka/${notransaksiwal}`);
            if (response.status === 200) {
                const noindextransnext = parseInt(response.data.notransaksi.toString().substring(5, 10)) + 1;
                const notransaksi = notransaksiwal + noindextransnext.toString().padStart(6, '0');
                setFormData((prevData) => ({
                    ...prevData,
                    noTransaksi: notransaksi,
                }));
            }
        } catch (error) {
            setFormData((prevData) => ({
                ...prevData,
                noTransaksi: notransaksiwal + '000001',
            }));
        }
    };

    const handleBlur = async () => {
        if (!formData.noAnggota || formData.noAnggota.length < 7) {
            setFormData((prev) => ({
                ...prev,
                noAnggota: "",
                nama: "",
                unitkerja: "",
                saldoAwl: 0,
                jumlah: 0,
                saldoAkhir: 0,
                anggota_mnsuka: "0",
            }));
            return;
        }
        try {
            const response = await api.get(`/api/anggota/${formData.noAnggota}`);
            if (response.data.anggota_mnsuka === "0") {
                alert("Bukan Anggota Manasuka");
                handleReset();
                return;
            }
            if (response.data) {
                setFormData((prev) => ({
                    ...prev,
                    nama: response.data.nama || "",
                    unitkerja: response.data.unitkerja || "",
                    anggota_mnsuka: response.data.anggota_mnsuka || "0",
                }));
            }
            const response2 = await api.get(`/api/transaksi/saldosimpananmanasuka/${periode}/${formData.noAnggota}`);
            if (response2.data) {
                setFormData((prev) => ({
                    ...prev,
                    saldoAwl: response2.data.saldoakh || 0,
                }));
            }
        } catch (error) {
            alert("Data anggota tidak ditemukan!");
            handleReset();
        }
    };

    const handleSubmit = async () => {
        const tanggal = new Date(formData.tglTransak);
        const yyyymm = `${String(tanggal.getFullYear())}${String(tanggal.getMonth() + 1).padStart(2, "0")}`;
        
        if (yyyymm !== periode) {
            alert(`Tanggal transaksi tidak sesuai dengan periode`);      
            handleReset();
            return;
        }

        const datasimpan = {
            notransaksi: formData.noTransaksi || "",
            tgltransak: formData.tglTransak || "",
            noanggota: formData.noAnggota || "",
            kdtrans: formData.jenisTransaksi || "1",
            debet: formData.jenisTransaksi === "2" ? `${formData.jumlah}` : "0",
            kredit: formData.jenisTransaksi === "1" ? `${formData.jumlah}` : "0",
            saldoawl: `${formData.saldoAwl}` || 0,
            saldo: `${formData.saldoAkhir}` || 0,
            kduser: kode,
            notransumum: "-"
        };     
        try {
            const response = await api.post("/api/transaksi/simpananmanasuka", datasimpan);
            //console.log(response.status)
            if (response.status === 201) {
                alert("Data berhasil disimpan!");
                const data = await fetchTransaksiManasuka(`${formData.noTransaksi}`);
                if (data) {
                    TransaksiManasukapdf(data);
                }
                handleReset(); // reset form
            } else {
                alert(`Gagal menyimpan data. Status: ${response.status}`);
            }
        } catch (error) {
            alert("Gagal menyimpan data.");
        }
    };

    const handleReset = () => {
        setFormData({
            noTransaksi: "",
            tglTransak: tglSekarang, // Pastikan tanggal tetap terkunci saat reset
            noAnggota: "",
            nama: "",
            unitkerja: "",
            saldoAwl: 0,
            jenisTransaksi: "1",
            jumlah: 0,
            kduser : "",
            notransumum:"-",
            saldoAkhir: 0,
        });
        GenereateNoTrans();
    };

    const fetchTransaksiManasuka = async (notransaksi) => {
      if (!notransaksi) {
        alert("No Transaksi masih kosong.");
        return null;
      }
      try {
        const response = await api.get(`/api/transaksi/gettransaksimanasuka/${notransaksi}`);        
        if (!response.data || response.data.length === 0) {
          alert("Tidak ada data transaksi Manasuka untuk dicetak.");
          return null;
        }
    
        return response.data;
      } catch (error) {
        alert("Gagal mengambil data transaksi Manasuka.");        
        return null;
      }
    };

    return (
        <div className="container mt-5 d-flex justify-content-center align-items-center">
            <div className="card card-info" style={{ width: "600px" }}>
                <div className="card-header">
                    <h3 className="card-title">Transaksi Manasuka</h3>
                </div>
                <div className="card-body">
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">No. Transaksi</label>
                        <div className="col-sm-3">
                            <input
                                type="text"
                                className="form-control"
                                name="noTransaksi"
                                value={formData.noTransaksi}
                                onChange={handleInputChange}
                                readOnly
                            />
                        </div>
                        <div className="col-auto">
                            <button className="btn btn-primary" style={{ backgroundColor: "blue", color: "white" }} onClick={GenereateNoTrans}>Click</button>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Tanggal</label>
                        <div className="col-sm-4">
						<input type="date" className="form-control" name="tglTransak" value={formData.tglTransak} onChange={handleInputChange} />                          
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">No. Anggota</label>
                        <div className="col-sm-4">
                            <input
                                type="text"
                                className="form-control"
                                name="noAnggota"
                                value={formData.noAnggota}
                                onBlur={handleBlur}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Nama</label>
                        <div className="col-sm-7">
                            <input
                                type="text"
                                className="form-control"
                                name="nama"
                                value={formData.nama}
                                readOnly
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Unit Kerja</label>
                        <div className="col-sm-7">
                            <input
                                type="text"
                                className="form-control"
                                name="unitkerja"
                                value={formData.unitkerja}
                                readOnly
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Saldo Awal</label>
                        <div className="col-sm-4">
                            <input
                                type="text"
                                className="form-control no-spinner"
                                name="saldoAwl"
                                value={formatCurrency(formData.saldoAwl)}
                                style={{ textAlign: "right" }}
                                readOnly
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Jenis Transaksi</label>
                        <div className="col-sm-4">
                            <select className="form-control" name="jenisTransaksi" value={formData.jenisTransaksi} onChange={handleInputChange}>
                                <option value="1">Setoran</option>
                                <option value="2">Penarikan</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Jumlah</label>
                        <div className="col-sm-4">
                            <input
                                type="text"
                                className="form-control no-spinner"
                                name="jumlah"
                                value={formatCurrency(formData.jumlah)}
                                onChange={handleInputChange}
                                style={{ textAlign: "right" }}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Saldo Akhir</label>
                        <div className="col-sm-4">
                            <input
                                type="text"
                                className="form-control no-spinner"
                                name="saldoAkhir"
                                value={formatCurrency(formData.saldoAkhir)}
                                style={{ textAlign: "right" }}
                                readOnly
                            />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-secondary" onClick={handleReset}>Batal</button>
                        <button className="btn btn-primary" onClick={handleSubmit}>Simpan</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TransaksiManasuka;
